import { useEffect, useState } from "react";

const TONES = {
  blue: "bg-[#DCE6F2] border-[#B4C4D8] hover:bg-[#D2DEEC]",
  peach: "bg-[#FCE9D2] border-[#E5C59C] hover:bg-[#F9E0C1]",
  yellow: "bg-[#FCF8D6] border-[#E2D896] hover:bg-[#F8F2C4]",
  white: "bg-white border-[#C9D3E0] hover:bg-[#F1F5FA]",
};

export function TKey({ children, onClick, tone = "blue", className = "", testid, disabled, active, style }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} data-testid={testid} style={style}
      className={`min-w-0 min-h-[64px] rounded-[2px] border px-1.5 py-1 grid place-items-center text-center text-[11px] font-bold uppercase leading-tight text-[#1E2A3A] shadow-[inset_0_1px_0_#fff] active:translate-y-px transition-[background-color,transform] disabled:opacity-40 ${TONES[tone]} ${active ? "!border-[#C0392B] ring-1 ring-[#C0392B]" : ""} ${className}`}>
      {children}
    </button>
  );
}

export function TKeypad({ onKey, labels }) {
  const d = (k, extra = "") => <TKey key={k} onClick={() => onKey(k)} className={`!text-3xl !font-normal ${extra}`} testid={`tm-key-${k === "." ? "dot" : k}`}>{k}</TKey>;
  return (
    <div className="grid grid-cols-4 grid-rows-4 gap-1 h-[300px]" data-testid="tm-keypad">
      {d("7")}{d("8")}{d("9")}<TKey onClick={() => onKey("az")} testid="tm-key-az">A … Z</TKey>
      {d("4")}{d("5")}{d("6")}<TKey onClick={() => onKey("clear")} testid="tm-key-clear">{labels.clear}</TKey>
      {d("1")}{d("2")}{d("3")}<TKey onClick={() => onKey("enter")} className="row-span-2" testid="tm-key-enter">{labels.enter}</TKey>
      {d("0")}{d("00")}{d(".")}
    </div>
  );
}

export function Clock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 15000); return () => clearInterval(id); }, []);
  return <span dir="ltr" className="text-[#C0392B] text-lg" data-testid="tm-clock">{now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</span>;
}

export const Box = ({ children, className = "", testid }) => (
  <div className={`bg-white border border-[#C9D3E0] px-2 py-1 text-[12px] font-bold text-[#1E2A3A] ${className}`} data-testid={testid}>{children}</div>
);
